export const colors = {
  dark: '#17181A',
  light: '#F8F8F8',
  primary: '#E53E3E',
  plight: '#FED7D7',
  secondary: '#6C63FF',
  surface: '#222626',
  gray: '#6E6D6E',
  smoke: '#DDDDDD',
  white: '#FFFFFF',
  modal: '#2226263F',
};
